import React from 'react';
import { Button } from 'antd';
import { setDesktopViewport } from '@hooks/useResponsive';
import { LogoIcon, MobileWarnIcon } from '@icons';
import './BlockMobile.less';

function BlockMobile() {
  const openDesktopVersion = () => {
    setDesktopViewport();
  };

  return (
    <div className="block-mobile_container">
      <div className="block-mobile_logo">
        <LogoIcon />
      </div>
      <div className="block-mobile_icon">
        <MobileWarnIcon />
      </div>
      <div className="block-mobile_title">
        It looks like you are using a mobile device
      </div>
      <div className="description">
        StreamWork has limited functionality on mobile browsers. To get the most
        out of StreamWork, switch to desktop.
      </div>

      <Button
        style={{ marginTop: 16 }}
        type="ghost"
        size="large"
        onClick={openDesktopVersion}
      >
        Enter desktop site
      </Button>
    </div>
  );
}

export default BlockMobile;
